<template>
  <div>
    <div class="top-nav">
      <div class="container">
        <ul style="float:left;padding:0;">
          <li class="login">
            <span>
              <a href="https://home.usoftchina.com/" target="_blank" rel="noopener noreferrer">
                <img style="width: 18px;margin-top: -3px;" src="/static/img/Uhome.png" alt />华商云服
              </a>
            </span>
          </li>
        </ul>
        <ul style="float:right">
          <li v-if="!loginStatus">
            <span style="margin-right:5px;" v-if="!loginStatus" @click="login">
              <img style="width: 20px;" src="/static/img/login.png" alt />&ensp;登录
            </span>
          </li>
          <li v-if="!loginStatus">
            <span style="margin-right:20px;" v-if="!loginStatus" @click="upRegister">
              &ensp;免费注册
            </span>
          </li>
          <li v-if="!loginStatus">
            <span>
              <a
                @click="jumptohome('home')"
                href="javascript:;"
                rel="noopener noreferrer"
                style="color:white"
              >
                <img style="width: 18px;" src="/static/img/Uhome.png" alt />&ensp;云系统首页
              </a>
            </span>
          </li>
          <li v-if="loginStatus">
            <!-- 用户名/退出 -->
            <span class="user-info">
              <span class="user-name">欢迎您，{{account.realname || account.username}} |</span>
              <!-- 切换企业列表 -->
              <span v-if="hasCompanyId && companyList.length>1" class="change-company">
                <el-dropdown @command="changeCompany" placement="bottom" class="el-dropdown">
                  <span class="el-dropdown-link">
                    {{account.defaultCompany.name}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu class="dropdown-menu-company" slot="dropdown">
                    <el-dropdown-item disabled>您可以切换至以下账户：</el-dropdown-item>
                    <el-dropdown-item
                      :command="d"
                      v-for="(d , i) in companyList"
                      :key="i"
                    >{{d.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <span v-else-if="hasCompanyId">{{account.defaultCompany.name}}</span>
              <a v-if="hasCompanyId" class="btn-logout" @click="logout()">[退出]</a>
              <el-button v-if="hasCompanyId" @click="loginDefault()" class="x-btn" size="mini" type="primary">进入系统</el-button>
            </span>
            <span v-if="!hasCompanyId" style="cursor:default;">个人账户</span>
            <a v-if="hasCompanyId" style="margin-right:4px;" :href="$url.accountCenter + '/index.html'" target="_blank">
              <span style="color: white">| 账户中心</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div id="navigation" class="navbar-inverse">
      <div class="container clearfix" style="padding: 10px 0">
        <div class="navbar-header" style="padding-right:30px;width:28%">
          <h1 class="navbar-brand">
            <a @click="jumptohome('home')" href="javascript:;">
              <img class="logo-img" src="/static/img/header-logo.png" alt />
            </a>
          </h1>
        </div>
        <div class="navbar-left" style="width:30%">
          <ul id="nav" class="nav navbar-nav menu">
            <li class="xs">
              <a @click="jumptotrade('trade')" :class="'trade'==actived?'active':''">
                <span>贸易云</span>
              </a>
            </li>
            <!--
            <li class="xs">
              <a @click="jumptofinancial('financial')" :class="'financial'==actived?'active':''">
                <span>金融云</span>
              </a>
            </li>
            -->
            <li class="xs">
              <a @click="jumptomake('make')" :class="'make'==actived?'active':''">
                <span>制造云</span>
              </a>
            </li>
          </ul>
        </div>
        <div style="margin-right:2%;padding-top: 20px" class="nav navbar-nav navbar-right phonebox">
          <img style="height:45px;" class="phone" src="/static/img/phone.png" alt />
        </div>
      </div>
    </div>
    <!-- 登录注册 -->
    <loginbox></loginbox>
    <!-- 企业开通盒子 -->
    <openupbox></openupbox>
  </div>
</template>

<script>
import Session from "@/utils/session";
import { setInterval, clearInterval } from "timers";
import loginbox from "../conenter/loginbox";
import openupbox from "../conenter/openupbox";
export default {
  components: {
    loginbox: loginbox,
    openupbox: openupbox,
  },
  data() {
    return {
      isLogin: false,
      isRegister: false,
      account: null,
      isfeature: this.$route.params.isfeature,
      timer: null,
      loginBy: true,
      actived: "home",
      companyList: [],
      // mytoken: Session.get(), //本地储存的用户信息
    };
  },
  computed:{
    loginStatus() {
      return this.$store.state.loginStatus;
    },
    hasCompanyId() {
      return this.$store.state.hasCompanyId;
    }
  },
  created() {
    this.$ajax({
      url: this.$url.api + "/api/auth/info",
      method: "get",
      async: false,
      withCredentials: true,
      headers: {
        Authorization: Session.getToken() || "",
      },
    }).then((res) => {
      const data = res.data.data;
      if (data && data != null) {
        const session = data.token, account = data.account;
        this.companyList = account.companyId ? (account.companies || []).filter(c => c.id != account.companyId) : [];
        account.companies = account.companies || [];
        session.account = account;
        Session.set(session);

        this.account = Session.getAccount();

        //给仓库变量赋值
        this.$store.commit("setname", data.account.realname);
        this.$store.commit("setmobile", data.account.username);
        this.$store.commit("setcompany", data.account.defaultCompany?data.account.defaultCompany.name:'');

        //仓库设置登录状态
        this.$store.commit("setLoginStatustrue");

        //有企业信息时 跳转企业列表
        if (data.companyId) {
          // 带有合伙人邀请码
          let inviteCode = this.$route.query.code;
          if (inviteCode) {
            this.checkPartnerStatus(inviteCode, data.appId);
          } else if (this.$route.path != "/enterprise" && this.$route.path != "/home") {
            this.redirectApp(data.appId);
          }
        }
        //企业未开通
        else if (data.unauthorized) {
          this.$store.commit("setOpenUpshow", data.unauthorized);
        }
        //未选择企业登录
        else {
          if (account.companies.length) {
            //提示选择已开通的企业
            const me = this || _this;
            //点击首页按钮时不跳转企业列表
            if (!me.$parent.turnHome) {
              me.$router.push({ path: "/enterprise" });
            } else {
              me.$parent.turnHome = false;
            }
          } else {
            //提示注册新企业
            this.$router.push({ path: "/tradecloud" });
            this.$message.error("当前账号无绑定企业，请联系管理员添加或立即注册开通云系统");
            this.$store.commit("setCompanyIdNone");
          }
        }
      } else {
        // 按路由属性切换
        let routeName = this.$route.name;
        if (routeName == 'register') {
          this.$store.commit("clickregistertrue");
        } else if (routeName == 'login') {
          this.$store.commit("clicklogintrue");
        }
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener("scroll", this.handleFun);
  },
  mounted() {
    // 从本地加载已经登录的信息
    this.account = Session.getAccount();
  },
  methods: {
    /**
     * 跳转具体应用页面
     */
    redirectApp(appId) {
      const me = this, account = this.account, company = account ? account.defaultCompany : null, dcName = company ? company.dcName: null, 
        route = me.$route.query.portal || (company && company.b2b ? 'supplier' : 'main');
      let url = me.$url.web[dcName || 'default'][appId || 'trade-app'], sameOrigin = url.indexOf(window.location.origin) == 0;
      if (!sameOrigin) {
        // 跨域直接传token
        url += '/#authorize/' + Session.get().token;
      } else {
        url += '/#' + route;
      }
      window.location.href = url;
    },
    setTurnHome() {
      this.turnHome = true;
    },
    login() {
      // 显示账户中心登录窗口
      this.isLogin = true;
      this.$store.commit("clicklogintrue");
    },
    upRegister() {
      this.isRegister = true;
      this.$store.commit("clickregistertrue");
    },
    register() {
      this.isRegister = true;
    },
    //退出
    logout() {
      const token = Session.getToken();
      // const frame = window.frames[window.frames.length - 1];
      // frame.postMessage("", "*");
      Session.remove();
      this.$store.commit("setLoginStatusfalse");

      this.$store.commit("setname", "");
      this.$store.commit("setmobile", "");
      this.$store.commit("setcompany", "");

      this.$ajax({
        url: this.$url.api + "/api/auth/logout",
        method: "get",
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      }).then((res) => {
        window.location.href = this.$url.ssoLogout.replace(
          "{RETURN_URL}",
          encodeURIComponent(window.location.origin)
        );
      }).catch(function(){
        window.location.href = this.$url.ssoLogout.replace(
          "{RETURN_URL}",
          encodeURIComponent(window.location.origin)
        );
      });
    },
    //添加鼠标滚轮事件，鼠标滚动的时候清除定时器，否则无法滚动
    scrollout() {
      clearInterval(this.timer);
    },
    //滚动动画封装
    animate(target) {
      clearInterval(this.timer);
      this.timer = setInterval(function () {
        var leader =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        var step = (target - leader) / 10;
        step = step > 0 ? Math.ceil(step) : Math.floor(step);
        leader = leader + step;
        $(document).scrollTop(leader);
        if (leader == target) {
          clearInterval(this.timer);
        }
      }, 5);
    },
    // 路由跳转
    jumptohome(e) {
      this.actived = e;
      this.$router.push("/home");
    },
    jumptotrade(e) {
      this.actived = e;
      this.$router.push("/tradecloud");
    },
    jumptofinancial(e) {
      this.actived = e;
    },
    jumptomake(e) {
      this.actived = e;
      this.$router.push("/makecloud");
    },

    changeCompany(d) {
      let session = Session.get();
      const me = this;
      this.$ajax({
        url: this.$url.api + "/api/auth/switch/company?companyId=" + d.id,
        method: "get",
        headers: {
          Authorization: session.token,
        },
      })
        .then((res) => {
          session.account.companyId = d.id;
          session.span = session.timestamp - new Date().getTime();
          session.token = res.data.data.token;
          Session.set(session);
          me.account.defaultCompany = d;
          me.redirectApp(d.app);
        });
    },

    //进入默认企业
    loginDefault() {
      let d = this.account.defaultCompany;
      if (d) {
        this.changeCompany(d);
      }
    },

    //个人信息菜单
    menuInfo(d) {
      if (d == "logout") {
        this.logout();
      }
    },

    /**
     * 检查绑定顾问的状态
     */
    checkPartnerStatus(inviteCode, appId) {
      const me = this, token = Session.getToken();
      me.$ajax({
        url: me.$url.api + "/api/account/partner/customer/status",
        params: {
          inviteCode
        },
        headers: {
          Authorization: token
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (data.hasPartner) {
            let partner = data.customer.partner;
            me.$alert(`您已经绑定了顾问 ${partner.name}(${partner.inviteCode})`, '警告', {
              confirmButtonText: '知道了',
              type: 'warning',
              callback: function() {
                me.redirectApp(appId);
              }
            });
          } else if (data.inviter) {
            this.$confirm(`${data.inviter.name}(${data.inviter.inviteCode}) 将成为您的专属顾问`, '提示', {
              confirmButtonText: '同意',
              cancelButtonText: '不同意',
              type: 'warning'
            }).then(() => {
              me.bindPartner(inviteCode, appId);
            }).catch(() => {
              me.redirectApp(appId);
            });
          } else {
            me.redirectApp(appId);
          }
        } else {
          me.$message.error(res.data.message);
        }
      });
    },
    /**
     * 绑定顾问
     */
    bindPartner(inviteCode, appId) {
      const token = Session.getToken();
      this.$ajax({
        url: this.$url.api + "/api/account/partner/customer/open",
        method: 'post',
        params: {
          inviteCode
        },
        headers: {
          Authorization: token
        }
      }).then(res => {
        let resp = res.data, data = resp.data;
        if (resp.success) {
          if (!data.hasPartner) {
            me.$alert('绑定顾问失败', '出错了', {
              confirmButtonText: '知道了',
              callback: function() {
                me.redirectApp(appId);
              }
            });
          } else {
            me.$alert(`${data.inviter.name} 是您的专属顾问了`, '提示', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: function() {
                me.redirectApp(appId);
              }
            });
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0;
}
.ts-box {
  height: 700px;
}
.shut {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}
.navbar-inverse {
  padding: 0px;
}
/* ele常见问题 */
.el-menu-demo {
  border-bottom: 0 !important;
  padding: 0px 10px !important;
}
.el-submenu {
  padding: 0px 10px !important;
}
.el-menu-demo >>> div {
  font-size: 16px !important;
  background: #1c1f48 !important;
  border-bottom: 0 !important;
}
.el-menu-demo >>> .el-submenu__title:hover {
  background: #1c1f48 !important;
}
.el-menu-demo >>> .el-submenu__title {
  padding: 0px !important;
  height: 48px !important;
  line-height: 48px !important;
  border-bottom: 0 !important;
}
.el-menu-item:hover {
  background: #1e88f5 !important;
}

.el-dropdown {
  line-height: 16px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
  margin-left: 0px;
}

.dropdown-menu-company {
  background-color: #f6f6f6;
  max-height: 500px;
  overflow-y: auto;
}
.dropdown-menu-company .el-dropdown-menu__item:first-child {
  color: #577ECD !important;
  font-weight: 600;
}
.dropdown-menu-company .el-dropdown-menu__item:hover {
  background: #f6f6f6;
}
.dropdown-menu-info {
  background-color: #f6f6f6;
}
.dropdown-menu-info .el-dropdown-menu__item:hover {
  background: #f6f6f6;
}

.el-button--mini {
  padding: 4px 8px;
}
.el-button--primary {
  background-color: #70add3;
  border-color: #70add3;
}
.el-button--primary:hover {
  opacity: 0.9;
}
.btn-logout {
  margin: 0 15px 0 10px;
}
.btn-logout:hover {
  color: #70add3;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue